<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="title">添加服务类型</div>
      <div class="box">
        <div class="form">
          <el-form ref="form" :rules="rules" :model="form" label-width="160px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="服务类型名称" prop="name">
                  <el-input v-model="form.name" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="编码" prop="code">
                  <el-input v-model="form.code" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="定价(元/年)" prop="amount">
                  <el-input
                    v-model="form.amount"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btns">
            <el-button type="primary" @click="submitForm('form')"
              >保存信息</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addServiceType } from '@/api/serviceType';
import { FormValidators } from '@/utils/validate';

export default {
  data() {
    return {
      isShowSelect: false,
      rules: {
        name: [
          { required: true, message: '请输入服务类型名称!', trigger: 'blur' },
        ],
        code: [{ required: true, message: '请输入编码!', trigger: 'blur' }],
        amount: [
          { required: true, message: '请输入定价!', trigger: 'blur' },
          {
            validator: FormValidators.numberOrPoint,
            message: '请输入数字',
            trigger: 'blur',
          },
        ],
      },
      form: {
        name: '',
        code: null,
        amount: '',
      },
    };
  },

  methods: {
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addServiceType(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功!');
              this.$router.back(-1);
            }
          });
        }
      });
    },
    //非空判断
    isNotEmpty(str) {
      if (str != null && str != '' && str.trim().length > 0) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
.formedit {
  input::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #fff !important;
  }
  i {
    display: none;
  }
  .el-input.is-disabled .el-input__inner {
    cursor: auto;
    background-color: #fff;
    border: 0;
  }
}
.objecyTree {
  //margin-left: 97px;
  position: absolute;
  overflow: auto;
  z-index: 100;
  //height: 200px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
  top: 47px;
}
.width-220 {
  width: 100%;
}
</style>
